/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AffidavitEligibilityTemplate } from './';
import {
    AffidavitEligibilityTemplateFromJSON,
    AffidavitEligibilityTemplateFromJSONTyped,
    AffidavitEligibilityTemplateToJSON,
} from './';
import type { ComplianceFileSource } from './';
import {
    ComplianceFileSourceFromJSON,
    ComplianceFileSourceFromJSONTyped,
    ComplianceFileSourceToJSON,
} from './';
import type { DocumentTypeResource } from './';
import {
    DocumentTypeResourceFromJSON,
    DocumentTypeResourceFromJSONTyped,
    DocumentTypeResourceToJSON,
} from './';
import type { FreelancerComplianceFileResource } from './';
import {
    FreelancerComplianceFileResourceFromJSON,
    FreelancerComplianceFileResourceFromJSONTyped,
    FreelancerComplianceFileResourceToJSON,
} from './';
import type { ProviderValidationStatus } from './';
import {
    ProviderValidationStatusFromJSON,
    ProviderValidationStatusFromJSONTyped,
    ProviderValidationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerCompanyDocumentsResource
 */
export interface FreelancerCompanyDocumentsResource {
    /**
     * 
     * @type {FreelancerComplianceFileResource}
     * @memberof FreelancerCompanyDocumentsResource
     */
    complianceFile: FreelancerComplianceFileResource;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyDocumentsResource
     */
    documentLabel?: string;
    /**
     * 
     * @type {DocumentTypeResource}
     * @memberof FreelancerCompanyDocumentsResource
     */
    documentType: DocumentTypeResource;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyDocumentsResource
     */
    documentTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyDocumentsResource
     */
    documentTypeTooltip?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCompanyDocumentsResource
     */
    isExpiringSoon?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerCompanyDocumentsResource
     */
    legalValidityDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerCompanyDocumentsResource
     */
    uploadDate?: Date;
    /**
     * 
     * @type {ProviderValidationStatus}
     * @memberof FreelancerCompanyDocumentsResource
     */
    providerValidationStatus?: ProviderValidationStatus;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyDocumentsResource
     */
    refusalReasonMessage?: string;
    /**
     * 
     * @type {ComplianceFileSource}
     * @memberof FreelancerCompanyDocumentsResource
     */
    source: ComplianceFileSource;
    /**
     * 
     * @type {AffidavitEligibilityTemplate}
     * @memberof FreelancerCompanyDocumentsResource
     */
    affidavitEligibilityTemplate?: AffidavitEligibilityTemplate;
}

/**
 * Check if a given object implements the FreelancerCompanyDocumentsResource interface.
 */
export function instanceOfFreelancerCompanyDocumentsResource(value: object): value is FreelancerCompanyDocumentsResource {
    if (!('complianceFile' in value) || value['complianceFile'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('documentTypeId' in value) || value['documentTypeId'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function FreelancerCompanyDocumentsResourceFromJSON(json: any): FreelancerCompanyDocumentsResource {
    return FreelancerCompanyDocumentsResourceFromJSONTyped(json, false);
}

export function FreelancerCompanyDocumentsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyDocumentsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'complianceFile': FreelancerComplianceFileResourceFromJSON(json['complianceFile']),
        'documentLabel': json['documentLabel'] == null ? undefined : json['documentLabel'],
        'documentType': DocumentTypeResourceFromJSON(json['documentType']),
        'documentTypeId': json['documentTypeId'],
        'documentTypeTooltip': json['documentTypeTooltip'] == null ? undefined : json['documentTypeTooltip'],
        'isExpiringSoon': json['isExpiringSoon'] == null ? undefined : json['isExpiringSoon'],
        'legalValidityDate': json['legalValidityDate'] == null ? undefined : (new Date(json['legalValidityDate'])),
        'uploadDate': json['uploadDate'] == null ? undefined : (new Date(json['uploadDate'])),
        'providerValidationStatus': json['providerValidationStatus'] == null ? undefined : ProviderValidationStatusFromJSON(json['providerValidationStatus']),
        'refusalReasonMessage': json['refusalReasonMessage'] == null ? undefined : json['refusalReasonMessage'],
        'source': ComplianceFileSourceFromJSON(json['source']),
        'affidavitEligibilityTemplate': json['affidavitEligibilityTemplate'] == null ? undefined : AffidavitEligibilityTemplateFromJSON(json['affidavitEligibilityTemplate']),
    };
}

export function FreelancerCompanyDocumentsResourceToJSON(value?: FreelancerCompanyDocumentsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'complianceFile': FreelancerComplianceFileResourceToJSON(value['complianceFile']),
        'documentLabel': value['documentLabel'],
        'documentType': DocumentTypeResourceToJSON(value['documentType']),
        'documentTypeId': value['documentTypeId'],
        'documentTypeTooltip': value['documentTypeTooltip'],
        'isExpiringSoon': value['isExpiringSoon'],
        'legalValidityDate': value['legalValidityDate'] == null ? undefined : ((value['legalValidityDate']).toISOString().substring(0,10)),
        'uploadDate': value['uploadDate'] == null ? undefined : ((value['uploadDate']).toISOString()),
        'providerValidationStatus': ProviderValidationStatusToJSON(value['providerValidationStatus']),
        'refusalReasonMessage': value['refusalReasonMessage'],
        'source': ComplianceFileSourceToJSON(value['source']),
        'affidavitEligibilityTemplate': AffidavitEligibilityTemplateToJSON(value['affidavitEligibilityTemplate']),
    };
}

